import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding-top: 0px;
`;

const Container = styled.div.attrs({ className: 'app-container' })`
  width: 100%;
  margin: 0 auto;
`;

const GalleryPage = () => {
    // Sample gallery data
    const galleryItems = [
        {
            id: 1,
            title: "Wedding Anniversary",
            description: "Paris, France • August 12, 2018",
            imageUrl: "/images/gallery/wedding-anniversary.jpg",
            category: "classic"
        },
        {
            id: 2,
            title: "Baby's Birth",
            description: "New York, USA • May 5, 2021",
            imageUrl: "/images/gallery/baby-birth.jpg",
            category: "minimal"
        },
        {
            id: 3,
            title: "First Date",
            description: "Tokyo, Japan • April 17, 2016",
            imageUrl: "/images/gallery/first-date.jpg",
            category: "colorful"
        },
        {
            id: 4,
            title: "Graduation Day",
            description: "Boston, USA • June 8, 2019",
            imageUrl: "/images/gallery/graduation.jpg",
            category: "classic"
        },
        {
            id: 5,
            title: "New Home",
            description: "Vancouver, Canada • September 30, 2020",
            imageUrl: "/images/gallery/new-home.jpg",
            category: "minimal"
        },
        {
            id: 6,
            title: "Proposal Moment",
            description: "Santorini, Greece • July 22, 2017",
            imageUrl: "/images/gallery/proposal.jpg",
            category: "colorful"
        }
    ];

    // Filter state
    const [activeFilter, setActiveFilter] = useState('all');

    // Filter categories
    const categories = [
        { id: 'all', name: 'All Maps' },
        { id: 'classic', name: 'Classic' },
        { id: 'minimal', name: 'Minimal' },
        { id: 'colorful', name: 'Colorful' }
    ];

    // Filter items based on active filter
    const filteredItems = activeFilter === 'all'
        ? galleryItems
        : galleryItems.filter(item => item.category === activeFilter);

    return (
        <PageContainer>
            <Container>
              <div className="gallery-section flex flex-col items-center justify-start w-full !bg-cover h-[70vw] md:h-[50vw] !bg-center pt-[14vw]">
              <h2 className="text-white text-[30px] md:text-[65px] font-normal text-center leading-none">The stars aligned<br/>on your special night</h2>
              <p className="text-white font-normal text-center leading-tight max-w-[740px] mx-auto px-20 text-[14px] md:text-[20px] mt-3">
              Explore our collection of unique styles — from minimalistic to artistic. Each design is crafted to highlight the beauty of your special moment. Find the one that best tells your story.
              </p>
              </div>

              <div className="grid !grid-cols-2 md:!grid-cols-4 gap-8 w-full px-8 md:px-16 mt-[60px] md:mt-[120px] relative z-10">
                <div className="flex flex-col items-center transition-transform duration-300 hover:scale-105 cursor-pointer mb-6">
                <img src="/images/product-1.png" className="w-full"></img>
                <p className="text-2sm w-full mx-auto text-left text-[#A0A0A0] pr-[10%] mt-4">Stellar Simplicity</p>
                  <p className="text-lg w-full mx-auto text-left">BASIC</p>
                </div>

                <div className="flex flex-col items-center transition-transform duration-300 hover:scale-105 cursor-pointer mb-6">
                <img src="/images/product-2.png" className="w-full"></img>
                  <p className="text-2sm w-full mx-auto text-left text-[#A0A0A0] pr-[10%] mt-4">Orbit</p>
                  <p className="text-lg w-full mx-auto text-left">€ 5.00</p>
                </div>

                <div className="flex flex-col items-center transition-transform duration-300 hover:scale-105 cursor-pointer mb-6">
                <img src="/images/product-3.png" className="w-full"></img>
                  <p className="text-2sm w-full mx-auto text-left text-[#A0A0A0] pr-[10%] mt-4">Constellation Frame</p>
                  <p className="text-lg w-full mx-auto text-left">€ 5.00</p>
                </div>

                <div className="flex flex-col items-center transition-transform duration-300 hover:scale-105 cursor-pointer mb-6">
                <img src="/images/product-4.png" className="w-full"></img>
                  <p className="text-2sm w-full mx-auto text-left text-[#A0A0A0] pr-[10%] mt-4">Celestial Corners</p>
                  <p className="text-lg w-full mx-auto text-left">€ 5.00</p>
                </div>

                <div className="flex flex-col items-center transition-transform duration-300 hover:scale-105 cursor-pointer mb-6">
                <img src="/images/product-5.png" className="w-full"></img>
                  <p className="text-2sm w-full mx-auto text-left text-[#A0A0A0] pr-[10%] mt-4">Starlit Halo</p>
                  <p className="text-lg w-full mx-auto text-left">€ 10.00</p>
                </div>

                <div className="flex flex-col items-center transition-transform duration-300 hover:scale-105 cursor-pointer mb-6">
                <img src="/images/product-6.png" className="w-full"></img>
                  <p className="text-2sm w-full mx-auto text-left text-[#A0A0A0] pr-[10%] mt-4">Lunar Harmony</p>
                  <p className="text-lg w-full mx-auto text-left">€ 10.00</p>
                </div>

                <div className="flex flex-col items-center transition-transform duration-300 hover:scale-105 cursor-pointer mb-6">
                <img src="/images/product-7.png" className="w-full"></img>
                  <p className="text-2sm w-full mx-auto text-left text-[#A0A0A0] pr-[10%] mt-4">Astro Mechanics</p>
                  <p className="text-lg w-full mx-auto text-left">€ 15.00</p>
                </div>

                <div className="flex flex-col items-center transition-transform duration-300 hover:scale-105 cursor-pointer mb-6">
                <img src="/images/product-8.png" className="w-full"></img>
                  <p className="text-2sm w-full mx-auto text-left text-[#A0A0A0] pr-[10%] mt-4">Cosmic Crown</p>
                  <p className="text-lg w-full mx-auto text-left">€ 25.00</p>
                </div>          
              </div>

              <div className="flex justify-center mt-12 relative z-10">
                <Link to="/create" className="button-new">Create Your Star Map</Link>                
              </div>

              <div className="relative">
              <img src="/images/gradients/gradient-3.svg" alt="Gradient" className="absolute top-[-280px] left-[-120px] w-[688px] h-auto z-[5] opacity-50" />
              </div>

              <div className="relative px-8 md:px-16 pb-[120px] overflow-y-hidden">
                <img src="/images/gradients/gradient-4.svg" alt="Gradient" className="absolute bottom-[-30px] md:bottom-[-190px] right-[-60px] w-[440px] md:w-[688px] h-auto z-[5] opacity-50" />
              
                <div className="w-full bg-black relative z-10 rounded-xl mt-[100px] md:pl-[60px] px-8 pb-[60px] md:pr-[120px] max-w-[1480px] mx-auto pt-[1px]">
                  <h2 className='text-white text-[30px] md:text-[51px] leading-tight font-normal mx-auto relative z-10 w-full text-center mt-[10%] md:mt-[5%]'>Give the Gift of a Memorable Moment</h2>
                  <p className='text-lg md:text-lg font-normal mx-auto relative z-10 w-full text-center mt-4 text-[#A961ED]'>with Our Gift Card</p>
                  
                  <div className="grid !grid-cols-1 md:!grid-cols-2 !gap-[20px] sm:grid-cols-1 w-full">
                    <div className="w-full flex justify-center items-center">
                    <img src="/images/gift-card-big.svg" class="w-full h-auto"></img>
                    </div>

                    <div className="w-full md:pl-[10%] flex flex-col justify-center items-center md:items-start">
                      <p className="text-[16px] md:text-[20px] max-w-[620px] text-center md:text-left">
                      Gift card for creating a personalized star map! It's a unique and heartfelt way to capture an important moment in your loved one's life — a birthday, anniversary, or any special event. Make your gift more than just an item, but an unforgettable experience that will stay with them forever. 
                      <br/><br/>Choose the amount, and let them create their own starry memory!
                      </p>
                      <Link to="/gift-card" className="button-new mt-10">
                        Buy Gift Card
                      </Link>
                    </div>
                </div>

              </div>
            </div>
            </Container>
        </PageContainer>
    );
};

export default GalleryPage; 